var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_abstract_manager_interface = function () {
    OCS.Viewer.Interfaces.AbstractManager = {
        class_type: "Manager",
        class_name: "AbstractManager",
        manager_name: '',
        events: {},
        options: {
            debug: false
        },
        init: function (op) {

        },
        set_debug: function (val) {
            this.options.debug = val;
        },
        remove_registered_events: function () {
            Object.each(this.events, function (event_key) {
                this.event_manager.unsubscribe(event_key);
            }.bind(this));
        }
    }; // End OCS.Viewer.Interfaces.AbstractManager
};
OCS.Viewer.Functions.define_abstract_manager_interface();